'use client';

import { Toast } from '@base-ui/react';
import type { ReactNode } from 'react';

import { initializeGlobalToastManager } from '@repo/sds/utils/toast';

export interface SDSToastProviderProps {
  children: ReactNode;
}

const TOAST_DURATION = 5000; // 5 second duration
const TOAST_LIMIT = 3; // Fixed limit of 3 toasts at a time

// Initialize the global manager
const toastManager = initializeGlobalToastManager();

export function SDSToastProvider({ children }: SDSToastProviderProps) {
  return (
    <Toast.Provider limit={TOAST_LIMIT} timeout={TOAST_DURATION} toastManager={toastManager}>
      {children}
    </Toast.Provider>
  );
}
